import React, {useState} from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {Col,} from "reactstrap";

import LatestTranactionTab from "./CloudResourceTab";

import {useQuery,} from "react-query";

import {getServices} from "../../helpers/fakebackend_helper";


const CloudResource = props => {
  const {isLoading, error, data, isFetching} = useQuery({
    queryKey: ["cloudResource"], queryFn: getServices
  });

  if (isLoading) return "Loading...";

  if (error) return "An error has occurred: " + error.message;


  return (
    <React.Fragment>
      <div>
        <Col lg={12}>
          <LatestTranactionTab resourceId={1} services={data} tabId="1"/>

        </Col>
      </div>
    </React.Fragment>
  );
};

CloudResource.propTypes = {
  orders: PropTypes.array,
  onGetCloudResources: PropTypes.func,
};

export default withRouter(CloudResource);
